module.exports = __webpack_public_path__ + "media/images/icons/external-link-alt-e4342c39c40cdb2fd346dd844fec0166.svg";